import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const redmine = defineConnector({
  identifier: "redmine",
  name: "Redmine",
  tagLine: "Project management and issue tracking",
  logo,
  protocol: "http",
  tags: ["productivity", "engineering"],
  defaultUrlPattern: ({ instanceUrl }) => urlToPattern(instanceUrl),
  auth: (app) =>
    headerAuth([{ name: "X-Redmine-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enable API access and copy your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Redmine, enable the REST API in **Administration > Settings > API**, then copy your API key from your account page. Redmine accepts the key as the `X-Redmine-API-Key` header.",
        },
      ],
    },
    {
      title: "Enter your Redmine details",
      items: [
        {
          kind: "url",
          label: "Redmine base URL",
          required: true,
          placeholder: "https://redmine.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://redmine.example.com"}/projects.json`,
  },
});
